import { useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  TextField,
  Typography,
} from "@mui/material";
import { FileUploader } from "react-drag-drop-files";

import BackButton from "../components/BackButton";
import { useAuth } from "../contexts/AuthContext";
import { centerAlignItems } from "../utils/styles";
import { useSnackbar } from "../contexts/SnackbarProvider";

const CUUnit = ({ onBack, bookId, unit = undefined }) => {
  const IS_CREATE = unit ? false : true;

  const Auth = useAuth();
  const [file, setFile] = useState(null);
  const { setSnackbarDetail } = useSnackbar();
  const [isUploading, setIsUploading] = useState(false);
  const [needRefresh, setNeedRefresh] = useState(false);

  function addUnit(e) {
    e.preventDefault();
    setIsUploading(true);
    let formData = new FormData();

    if (IS_CREATE || e.target.title.value) {
      formData.append("title", e.target.title.value);
    }

    if (IS_CREATE || file) {
      formData.append("image", file);
    }

    if (IS_CREATE) {
      formData.append("bookId", bookId);
    }

    Auth.AuthenticatedServerCall({
      method: IS_CREATE ? "POST" : "PATCH",
      isFormData: true,
      body: formData,
      entity: `api/units${IS_CREATE ? "" : "/" + unit?.id}`,
    })
      .then((res) => {
        setNeedRefresh(true);
        setSnackbarDetail({
          open: true,
          message: res.message,
          severity: "success",
        });
        e.target.reset();
        setFile(null);
        setIsUploading(false);
      })
      .catch((error) => {
        setIsUploading(false);
        setSnackbarDetail({
          open: true,
          message: error.message,
          severity: "error",
        });
      });
  }

  return (
    <Box
      component="form"
      onSubmit={addUnit}
      sx={centerAlignItems}
      className="md-CUUnit"
    >
      <Typography variant="h3" textAlign="center">
        {IS_CREATE ? "Add New Unit" : "Edit Unit"}
      </Typography>
      <BackButton onBack={() => onBack(needRefresh)} />
      <TextField
        sx={{ m: 1, minWidth: "400px" }}
        label="title"
        id="title"
        required
        defaultValue={IS_CREATE ? "" : unit?.title}
      />
      <FileUploader
        handleChange={(img) => setFile(img)}
        name="file"
        types={["JPG", "PNG", "JPEG"]}
      />
      {file?.name && (
        <Typography gutterBottom variant="caption">
          {file.name}
        </Typography>
      )}

      <Button
        type="submit"
        variant="contained"
        sx={{ m: 1, minWidth: "200px" }}
        disabled={isUploading}
      >
        {isUploading ? <CircularProgress /> : "save"}
      </Button>
    </Box>
  );
};

export default CUUnit;
